import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';

import { NotFound } from '@/components/states/NotFound';
import { RouteErrorState } from '@/components/states/RouteErrorState';

import { routeTree } from '../routeTree.gen';

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultErrorComponent: RouteErrorState,
    defaultNotFoundComponent: NotFound,
    // Keep the previous screen visible while the next one loads rather than
    // flashing a blank shell — an operator mid-incident should never lose context.
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter;
  }
}
